<!---Template passengers-->
<div class="item-passenger" [ngClass]="{'item-passenger--active': inputCheck.checked && !isFlowMYBClosed}">
  <label class="custom-checkbox" [hidden]="isFlowMYBClosed">
    <input  type="checkbox" #inputCheck (change)="onSelect(inputCheck.checked) " 
      [(ngModel)]="passanger.isSelectedToCheckin" [disabled]="isDisabled"  />
    <span  class="checkmark" [ngClass]="{'bg-white':(isReadyForCheckIn || isHasCheckin || isNotDocuments) && !inputCheck.checked}"></span>
  </label>
  <div class="item-passenger-labels" (click)="onSelect(inputCheck.checked)">
    <div class="item-passenger-labels-title">
      <label class="item-passenger-label-check">
        {{truncateTextUi(passanger.displayName,'15') | titlecase }}
      </label>
      <img *ngIf="hasInfant" class="am-image-child" src="./assets/images/Infant.svg" alt="infant" />
    </div>
    <div class="item-passenger-label-info" *ngIf="!loadingStatusPassenger">
      <img [alt]="(copyEstatus | translate)" [src]="getIconEstatus"
        class="TitleFormAlert-icon" />
      <span>{{copyEstatus | translate}}</span>
    </div>
  </div>
  <button class="item-passenger-button" *ngIf="showEdit || isVerPass"
  [disabled]="isHasCheckin"
  [ngClass]="{'item-passenger-button--active': inputCheck.checked || isReadyForCheckIn || isHasCheckin}" (click)="onEdit()"
    type="button">
    <span>{{getCopyButton() | translate}}</span>
  </button><!-- Se bloquea en showEdit del controller -->
  <app-am-loading [typeLoading]="'COMPONENT_LOADING'" *ngIf="loadingStatusPassenger"></app-am-loading>
</div>
